/* Probably don't need this now that its in process.env but lets leave it since changing it may break things */
import React from 'react';

interface iResourceStrings {
    invoiceResearch: {
        toolTips;
    };
    manageExceptions: {
        toolTips;
    };
}

const ResourceStringContext = React.createContext({} as iResourceStrings);

const resourceStrings = {
    invoiceResearch: {
        toolTips: {
            billTo: '',
            carrier: 'See invoices from just a single carrier',
            mode: 'Narrow down the results by Transportation Mode, such as Less Than Loaded (LTL) or Truck Load (TL)',
            entryType: '',
            processed: 'The date Sunset processed an invoice for payment',
            checkDate:
                'The date Sunset sent the check to the carrier for an invoice',
            shipped: 'The date the carrier reports picking up the load',
            invoices: [
                '* = wildcard. Example: Use 1234* for invoice 12345 OR *2345 for 12345',
                'For multiple invoices use a comma. Example, 12345,12346,12347',
            ],
            airbillNum: [
                '* = wildcard. Example: Use 1234* for invoice 12345 OR *2345 for 12345',
                'For multiple invoices use a comma. Example, 12345,12346,12347',
            ],
            checks: '',
            status: '',
            shipper: 'Search based on the Shipper location or name',
            consignee: 'Search based on the Receiver location or name',
            referenceValue: '',
            referenceCodes: '',
            partyName:
                'Searches the Location name.  Use * for wildcard searches',
            partyAddress:
                'Searches the Street Address 1 field.  Use * for wildcard searches',
            partyCity: 'Use * for wildcard searches',
            partyState: '2 character State or Province code',
            partyPostal: 'US use Zip5, CN use 6 with no space',
        },
    },
    manageExceptions: {
        toolTips: {
            billTo: '',
            btnClearSel: 'Clear all selections in the grid',
            btnEntered:
                'Accept the selected invoices with their entered values',
            btnAudited:
                'Accept the selected invoices with their audited values',
            btnAdjusted:
                'Accept the selected invoices with their adjusted values',
            btnRefuse: 'Refuse the selected invoices',
            btnDelete: 'Delete the selected invoices',
        },
    },
} as iResourceStrings;

export const ResourceStringProvider = ({children}) => (
    <ResourceStringContext.Provider value={resourceStrings}>
        {children}
    </ResourceStringContext.Provider>
);

export const useResourceStrings = () => {
    const context = React.useContext(ResourceStringContext);
    if (context === undefined) {
        throw new Error(
            'ResourceStringContext must be used within a ResourceStringProvider'
        );
    }
    return context;
};
